import { render } from "./EditBankAccounts.vue?vue&type=template&id=9d3d5b74"
import script from "./EditBankAccounts.vue?vue&type=script&lang=js"
export * from "./EditBankAccounts.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Amaze-Portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__